/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Most_FlexibleInputs */

const en_plan_most_flexible = /** @type {(inputs: Plan_Most_FlexibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most flexible`)
};

const es_plan_most_flexible = /** @type {(inputs: Plan_Most_FlexibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más flexible`)
};

/**
* | output |
* | --- |
* | "Most flexible" |
*
* @param {Plan_Most_FlexibleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_most_flexible = /** @type {((inputs?: Plan_Most_FlexibleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Most_FlexibleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_most_flexible(inputs)
	return en_plan_most_flexible(inputs)
});